import { connect } from 'react-redux';

import { fetchMonitoringEvents } from 'api/events/events.actions';
import { fetchVgStatistics } from 'api/statistics/statistics.actions';
import { MonitoringVG } from './MonitoringVG';

const mapDispatchToProps = (dispatch: Function) => ({
  fetchEvents: ({ archived = false, active = false }) => dispatch(fetchMonitoringEvents(archived, active)),
  fetchStatistics: () => dispatch(fetchVgStatistics()),
});

export const MonitoringVGContainer = connect(null, mapDispatchToProps)(MonitoringVG);
